"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformToken = void 0;
const Jwt_1 = require("../util/Jwt");
class PlatformToken extends Jwt_1.Jwt {
    constructor(tokenType, token) {
        super(token);
        this.tokenType = tokenType;
    }
    get environmentId() {
        return this.audience;
    }
    get apiEndpoint() {
        return this.issuer;
    }
    isValid() {
        return super.isValid() && this.type === this.tokenType;
    }
}
exports.PlatformToken = PlatformToken;
//# sourceMappingURL=PlatformToken.js.map